<svg
  width="23"
  height="32"
  viewBox="0 0 23 32"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
  [attr.width]="size"
  [attr.height]="size"
  [ngClass]="class"
>
<rect x="0.5" y="0.5" width="22" height="31" fill="white" [attr.stroke]="fill"/>
<rect x="1" y="30" width="21" height="2" [attr.fill]="fill"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M5 6H18V8H5V6ZM5 11H18V13H5V11ZM15 16H5V18H15V16Z" [attr.fill]="fillAccent" />
</svg>
